export let serverIp;

const domain = 'praexo.io';

const { host } = window.location;
const parts = host.split('.');
const subdomain = parts[0];
const localhost = `http://${subdomain}.localhost/api`;
const prod = `http://${subdomain}.${domain}/api`;

// if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
//   // dev code
//   serverIp = localhost;
// } else {
//   // serverIp = 'http://airbnb.rest3.com/api';
//   serverIp = prod;
// }

serverIp = localhost;

export const MenuItems = [
  {
    path: '/panel',
    name: 'My Capital Raising'
  },
  {
    path: '/information',
    name: 'Information'
  },
  {
    path: '/feedbacks',
    name: 'Feedbacks'
  },
  {
    path: '/investors',
    name: 'Investors List'
  }
];
